import { useState } from 'react';

const topics = ['内容纠错', '条目补充', '功能建议', '合作咨询'];
const MAX_LENGTH = 500;

export default function AboutFeedbackForm() {
  const [topic, setTopic] = useState(topics[0]);
  const [nickname, setNickname] = useState('');
  const [email, setEmail] = useState('');
  const [content, setContent] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const submit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!content.trim()) {
      setError('请先填写反馈内容');
      return;
    }
    if (content.length > MAX_LENGTH) {
      setError(`反馈内容不能超过 ${MAX_LENGTH} 字`);
      return;
    }
    setError('');
    setSubmitted(true);
  };

  const reset = () => {
    setSubmitted(false);
    setNickname('');
    setEmail('');
    setContent('');
    setTopic(topics[0]);
  };

  return (
    <div id="feedback" className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
      {submitted ? (
        <div className="py-10 text-center">
          <span className="w-14 h-14 mx-auto rounded-full bg-accent-100 text-accent-700 flex items-center justify-center">
            <i className="ri-checkbox-circle-line text-2xl" />
          </span>
          <h3 className="mt-4 text-base font-bold text-foreground-950">反馈已收到</h3>
          <p className="mt-2 text-xs leading-6 text-foreground-500">
            感谢你的建议！本次为前端演示，内容未实际提交或存储。
          </p>
          <button
            type="button"
            onClick={reset}
            className="mt-5 h-9 px-4 rounded-md bg-background-100 border border-background-300 text-xs text-foreground-700 whitespace-nowrap hover:bg-background-200 transition-colors cursor-pointer"
          >
            再填一份
          </button>
        </div>
      ) : (
        <form onSubmit={submit} noValidate>
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-xs text-foreground-400">反馈类型</span>
            {topics.map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => setTopic(item)}
                className={`px-2.5 py-1 rounded-md text-xs whitespace-nowrap transition-colors cursor-pointer ${
                  topic === item
                    ? 'bg-primary-500 text-background-50 font-medium'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {item}
              </button>
            ))}
          </div>

          <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label htmlFor="feedback-nickname" className="block text-[11px] text-foreground-500 mb-1.5">
                称呼（选填）
              </label>
              <input
                id="feedback-nickname"
                name="nickname"
                value={nickname}
                onChange={(event) => setNickname(event.target.value)}
                placeholder="怎么称呼你"
                className="w-full h-10 px-3 text-sm rounded-md bg-background-100 border border-background-300 text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
              />
            </div>
            <div>
              <label htmlFor="feedback-email" className="block text-[11px] text-foreground-500 mb-1.5">
                联系邮箱（选填）
              </label>
              <input
                id="feedback-email"
                name="feedback_email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="便于我们回复你"
                className="w-full h-10 px-3 text-sm rounded-md bg-background-100 border border-background-300 text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
              />
            </div>
          </div>

          <div className="mt-3">
            <div className="flex items-center justify-between mb-1.5">
              <label htmlFor="feedback-content" className="text-[11px] text-foreground-500">
                反馈内容
              </label>
              <span className={`text-[11px] ${content.length > MAX_LENGTH ? 'text-accent-700' : 'text-foreground-400'}`}>
                {content.length}/{MAX_LENGTH}
              </span>
            </div>
            <textarea
              id="feedback-content"
              name="content"
              value={content}
              onChange={(event) => setContent(event.target.value.slice(0, MAX_LENGTH))}
              rows={5}
              maxLength={MAX_LENGTH}
              placeholder="描述你遇到的问题或建议，例如某个条目的年份有误…"
              className="w-full px-3 py-2.5 text-sm leading-6 rounded-md bg-background-100 border border-background-300 text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 resize-none"
            />
          </div>

          {error && (
            <p className="mt-2 text-[11px] text-accent-700 flex items-center gap-1">
              <i className="ri-error-warning-line" />
              {error}
            </p>
          )}

          <div className="mt-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <p className="text-[11px] text-foreground-400 order-2 sm:order-1">演示表单 · 不会真实提交任何数据</p>
            <button
              type="submit"
              className="order-1 sm:order-2 h-10 px-5 rounded-md bg-accent-500 hover:bg-accent-600 text-primary-950 text-sm font-semibold flex items-center justify-center gap-2 whitespace-nowrap transition-colors cursor-pointer"
            >
              <i className="ri-send-plane-line" />
              提交反馈
            </button>
          </div>
        </form>
      )}
    </div>
  );
}